export const PAYMENT_RATE_TYPE_OPTIONS = [
  { value: 'General_Regular', label: 'General Regular' },
  { value: 'General_Holiday', label: 'General Holiday' },
  { value: 'Time-sensitive', label: 'Time-sensitive' },
] as const;

export const JOB_RATE_LOCATION_TYPE_OPTIONS = [
  { value: '1', label: 'Home' },
  { value: '2', label: 'Onsite' },
  { value: '3', label: 'Hybrid' },
] as const;

export const JOB_RATE_LOCATION_TYPE_LABELS: Record<string, string> =
  Object.fromEntries(
    JOB_RATE_LOCATION_TYPE_OPTIONS.map((option) => [option.value, option.label]),
  );

export const JOB_RATE_UNIT_OPTIONS = [
  { value: '1', label: 'Per Hour' },
  { value: '2', label: 'Per Word' },
  { value: '3', label: 'Per Page' },
  { value: '4', label: 'Per Character' },
  { value: '5', label: 'Per Count' },
  { value: '6', label: 'Per Piece' },
  { value: '7', label: 'Per Task' },
  { value: '8', label: 'Per Hit' },
  { value: '9', label: 'Per Day' },
  { value: '10', label: 'Per Month' },
  { value: '11', label: 'Per Topic' },
  { value: '12', label: 'Per Minute' },
  { value: '13', label: 'Per Approved Hit' },
  { value: '14', label: 'Per Audio Hour' },
  { value: '15', label: 'Per Session' },
  { value: '16', label: 'Per Segment' },
] as const;

export const JOB_RATE_UNIT_LABELS: Record<string, string> = Object.fromEntries(
  JOB_RATE_UNIT_OPTIONS.map((option) => [option.value, option.label]),
);
